// extracted by mini-css-extract-plugin
export default {"tabBar":"TabBar_tabBar__BftFb","tab":"TabBar_tab__Grbge","active":"TabBar_active__Bjycm","icon":"TabBar_icon__RdLdn","label":"TabBar_label__wKZdE"};